import { useEffect, useState } from "react";
import { findRulesetIntersectionInProperties } from "../../pages/Products/components/RulesTable/helpers";
import { ValidationResponse, ValidatorNames } from "types/validation";

export default function useValidateRuletableRulesets({
  properties,
}: {
  properties: any;
}) {
  const [errorMessage, setErrorMessage] = useState<
    Pick<ValidationResponse, "message" | "validatorName">
  >({
    message: null,
    validatorName: ValidatorNames.WrongRulesetsInRuleTableProperties,
  });

  useEffect(() => {
    if (properties === null) {
      setErrorMessage({
        message: null,
        validatorName: ValidatorNames.WrongRulesetsInRuleTableProperties,
      });
      return;
    }
    if (
      !findRulesetIntersectionInProperties(properties).length &&
      properties.length
    ) {
      setErrorMessage({
        message: "no intersection found for properties rulesets",
        validatorName: ValidatorNames.WrongRulesetsInRuleTableProperties,
      });
      return;
    }
    setErrorMessage({
      message: null,
      validatorName: ValidatorNames.WrongRulesetsInRuleTableProperties,
    });
  }, [properties]);

  return errorMessage;
}
